"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseNotificationsSettings = void 0;
var swr_1 = __importDefault(require("swr"));
var inversify_react_1 = require("inversify-react");
var axios_1 = __importDefault(require("axios"));
var UseNotificationsSettings = function () {
    var apiBaseUrl = (0, inversify_react_1.useInjection)("apiBaseUrl");
    var url = "".concat(apiBaseUrl, "/notifications/settings");
    var _a = (0, swr_1.default)([url], function (args) { return fetchNotificationsSettings.apply(void 0, __spreadArray([], __read(args), false)); }, {
        revalidateOnFocus: false,
    }), data = _a.data, mutate = _a.mutate;
    function updater(updatedSettings) {
        return __awaiter(this, void 0, Promise, function () {
            var notificationSettings;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        notificationSettings = castToNotificationSettings(updatedSettings);
                        return [4, putNotificationsSettings(url, notificationSettings)];
                    case 1:
                        _a.sent();
                        return [4, mutate()];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    }
    return {
        settings: data,
        updater: updater,
    };
};
exports.UseNotificationsSettings = UseNotificationsSettings;
var fetchNotificationsSettings = function (url) { return __awaiter(void 0, void 0, Promise, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.get(url, { withCredentials: true })];
            case 1:
                response = _a.sent();
                return [2, castToUINotificationSettings(response.data)];
        }
    });
}); };
var putNotificationsSettings = function (url, settings) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, axios_1.default.put(url, settings, { withCredentials: true })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
var castViewAlertOnSettings = function (viewSetting) {
    if (viewSetting === -1)
        return { alertOn: "every" };
    if (viewSetting === 1)
        return { alertOn: "first" };
    return { alertOn: "custom", customNumber: viewSetting };
};
var castToUINotificationSettings = function (notificationSettings) {
    return {
        engagement: [
            {
                type: "toggle",
                setting: "comments",
                on: notificationSettings.comments,
                label: "Comment added or resolved",
            },
            {
                type: "toggle",
                setting: "engagement",
                on: notificationSettings.engagement,
                label: "Page engagement level changed",
            },
        ],
        viewership: [
            __assign({ type: "granular", setting: "views", on: notificationSettings.views !== 0, label: "Page viewed" }, (notificationSettings.views !== 0 && castViewAlertOnSettings(notificationSettings.views))),
            {
                type: "toggle",
                setting: "userIdentified",
                on: notificationSettings.userIdentified,
                label: "User identified",
            },
            {
                type: "toggle",
                setting: "declinedPage",
                on: notificationSettings.declinedPage,
                label: "User tried to view a declined page",
            },
            {
                type: "toggle",
                setting: "expiredLink",
                on: notificationSettings.expiredLink,
                label: "User tried to view expired link",
            },
        ],
        transaction: [
            {
                type: "toggle",
                setting: "accepted",
                on: notificationSettings.accepted,
                label: "Page accepted",
                disabled: true,
                tooltip: "Only sends when a page has been accepted by all",
            },
            {
                type: "toggle",
                setting: "partiallyAccepted",
                on: notificationSettings.partiallyAccepted,
                label: "Page partially accepted",
                disabled: true,
                tooltip: "For pages with multiple accepters. Get notified on acceptance by each individual accepter until a page is accepted by all",
            },
            {
                type: "toggle",
                setting: "acceptStalled",
                on: notificationSettings.acceptStalled,
                label: "Accept process stalled",
            },
            {
                type: "toggle",
                setting: "quoteChanged",
                on: notificationSettings.quoteChanged,
                label: "Quote changed",
            },
        ],
    };
};
var deriveNumericConfigRepresentation = function (views) {
    if ("alertOn" in views) {
        if (views.alertOn === "every")
            return -1;
        if (views.alertOn === "first")
            return 1;
        return views.customNumber;
    }
    return 0;
};
var castToNotificationSettings = function (updatedSettings) {
    var engagement = updatedSettings.engagement, viewership = updatedSettings.viewership, transaction = updatedSettings.transaction;
    var settings = __spreadArray(__spreadArray(__spreadArray([], __read(engagement), false), __read(viewership), false), __read(transaction), false);
    return settings.reduce(function (acc, setting) {
        var _a, _b;
        if (setting.type === "granular")
            return __assign(__assign({}, acc), (_a = {}, _a[setting.setting] = deriveNumericConfigRepresentation(setting), _a));
        return __assign(__assign({}, acc), (_b = {}, _b[setting.setting] = setting.on, _b));
    }, {});
};
